var collectionGalleryList = $("#bt32-csb_pswpContainer").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: "#bt32-csb_mainImage",
    dots: false,
    arrows: true,
    prevArrow:
        '<div class="sideList-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="18" height="18" viewBox="0 0 18 18"><defs><clipPath id="master_svg0_7_732"><rect x="-1" y="17" width="20" height="20" rx="0"/></clipPath></defs><g transform="matrix(0,-1,1,0,-18,18)" clip-path="url(#master_svg0_7_732)"><rect x="0" y="18" width="18" height="18" rx="0" fill="#FFFFFF" fill-opacity="0.009999999776482582" style="mix-blend-mode:passthrough"/><path d="M9.375,26.1642138L13.1678934,29.9571071L13.1680346,29.9569654Q13.3086586,30.097589499999998,13.4923925,30.1736946Q13.6761265,30.2497997,13.875,30.2498002Q13.9734707,30.2497997,14.0700502,30.2305889Q14.1666298,30.2113776,14.2576056,30.1736937Q14.3485813,30.1360102,14.4304581,30.0813022Q14.5123348,30.0265946,14.5819645,29.956965Q14.6515942,29.887334799999998,14.7063026,29.8054585Q14.7610111,29.7235823,14.7986946,29.6326065Q14.8363781,29.5416303,14.8555889,29.4450512Q14.8747997,29.3484716,14.8747997,29.25Q14.8747997,29.0511274,14.7986946,28.8673935Q14.7225895,28.6836588,14.5819654,28.5430346L14.5821066,28.5428932L10.0821071,24.04289317Q10.0124626,23.97324932,9.9305701,23.91853034Q9.848677200000001,23.86381149,9.757682800000001,23.826120500000002Q9.6666889,23.7884295,9.5700903,23.76921475Q9.4734912,23.75,9.375,23.75Q9.2765083,23.75,9.1799097,23.76921475Q9.0833106,23.7884295,8.992316200000001,23.826120500000002Q8.9013224,23.86381149,8.8194296,23.9185304Q8.7375369,23.97324932,8.6678932,24.04289317L4.16789317,28.5428932L4.16803467,28.5430346Q4.02741051,28.6836588,3.9513052699999998,28.867393Q3.87519997,29.0511274,3.87519997,29.25Q3.8752000300000002,29.3484716,3.89441091,29.4450507Q3.91362178,29.5416303,3.9513052699999998,29.6326065Q3.98898876,29.7235823,4.0436967,29.8054585Q4.09840465,29.887334799999998,4.16803467,29.956965Q4.2376647,30.0265946,4.31954092,30.0813026Q4.40141714,30.1360102,4.49239314,30.1736941Q4.58336911,30.2113781,4.6799487,30.2305889Q4.776528291,30.2497997,4.875,30.2498002Q5.07387257,30.2497997,5.25760686,30.1736946Q5.44134116,30.097589499999998,5.58196533,29.9569654L5.58210683,29.9571071L9.375,26.1642138Z" fill-rule="evenodd" fill="#141414" fill-opacity="1" style="mix-blend-mode:passthrough"/></g></svg></div>',
    nextArrow:
        '<div class="sideList-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="18" height="18" viewBox="0 0 18 18"><defs><clipPath id="master_svg0_7_732"><rect x="-1" y="17" width="20" height="20" rx="0"/></clipPath></defs><g transform="matrix(0,-1,1,0,-18,18)" clip-path="url(#master_svg0_7_732)"><rect x="0" y="18" width="18" height="18" rx="0" fill="#FFFFFF" fill-opacity="0.009999999776482582" style="mix-blend-mode:passthrough"/><path d="M9.375,26.1642138L13.1678934,29.9571071L13.1680346,29.9569654Q13.3086586,30.097589499999998,13.4923925,30.1736946Q13.6761265,30.2497997,13.875,30.2498002Q13.9734707,30.2497997,14.0700502,30.2305889Q14.1666298,30.2113776,14.2576056,30.1736937Q14.3485813,30.1360102,14.4304581,30.0813022Q14.5123348,30.0265946,14.5819645,29.956965Q14.6515942,29.887334799999998,14.7063026,29.8054585Q14.7610111,29.7235823,14.7986946,29.6326065Q14.8363781,29.5416303,14.8555889,29.4450512Q14.8747997,29.3484716,14.8747997,29.25Q14.8747997,29.0511274,14.7986946,28.8673935Q14.7225895,28.6836588,14.5819654,28.5430346L14.5821066,28.5428932L10.0821071,24.04289317Q10.0124626,23.97324932,9.9305701,23.91853034Q9.848677200000001,23.86381149,9.757682800000001,23.826120500000002Q9.6666889,23.7884295,9.5700903,23.76921475Q9.4734912,23.75,9.375,23.75Q9.2765083,23.75,9.1799097,23.76921475Q9.0833106,23.7884295,8.992316200000001,23.826120500000002Q8.9013224,23.86381149,8.8194296,23.9185304Q8.7375369,23.97324932,8.6678932,24.04289317L4.16789317,28.5428932L4.16803467,28.5430346Q4.02741051,28.6836588,3.9513052699999998,28.867393Q3.87519997,29.0511274,3.87519997,29.25Q3.8752000300000002,29.3484716,3.89441091,29.4450507Q3.91362178,29.5416303,3.9513052699999998,29.6326065Q3.98898876,29.7235823,4.0436967,29.8054585Q4.09840465,29.887334799999998,4.16803467,29.956965Q4.2376647,30.0265946,4.31954092,30.0813026Q4.40141714,30.1360102,4.49239314,30.1736941Q4.58336911,30.2113781,4.6799487,30.2305889Q4.776528291,30.2497997,4.875,30.2498002Q5.07387257,30.2497997,5.25760686,30.1736946Q5.44134116,30.097589499999998,5.58196533,29.9569654L5.58210683,29.9571071L9.375,26.1642138Z" fill-rule="evenodd" fill="#141414" fill-opacity="1" style="mix-blend-mode:passthrough"/></g></svg></div>',
    centerMode: true,
    centerPadding: "0",
    infinite: true,
    variableWidth: true,
    focusOnSelect: true,
    vertical: false,
    verticalSwiping: false,
    speed: 500,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                vertical: false,
                verticalSwiping: false,
                slidesToShow: 5,
                centerMode: true,
            },
        },
    ],
});

var collectionGallery = $("#bt32-csb_mainImage").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: "#bt32-csb_pswpContainer",
    speed: 500,
});

var dynamicGallery = lightGallery(document.body, {
    licenseKey: "DA7E83CA-6E474542-97592C9F-8A8DFF9D",
    dynamic: true,
    controls: false,
    download: false,
    plugins: [lgZoom],
    dynamicEl: [],
});

var chairUtils = {
    // Find one element.
    query: function (selector, root) {
        return (root || document).querySelector(selector);
    },
    // Find all elements as a real array.
    queryAll: function (selector, root) {
        return Array.prototype.slice.call((root || document).querySelectorAll(selector));
    },
    // Find one element by id.
    getById: function (id) {
        return document.getElementById(id);
    },
    // Parse JSON with a fallback value.
    parseJSON: function (value, fallback) {
        try {
            return JSON.parse(value || "");
        } catch (error) {
            return fallback;
        }
    },
    // Parse a JSON script tag by id.
    getJSONScript: function (id, fallback) {
        var script = document.getElementById(id);
        return script ? chairUtils.parseJSON(script.textContent, fallback) : fallback;
    },
    // Safely set text content.
    setText: function (target, value) {
        if (target) target.textContent = value == null ? "" : value;
    },
    // Safely set form value.
    setValue: function (target, value) {
        if (target) target.value = value == null ? "" : value;
    },
    // Safely set display style.
    setDisplay: function (target, value) {
        if (target) target.style.display = value;
    },
    // Safely set disabled state.
    setDisabled: function (target, disabled) {
        if (target) target.disabled = disabled;
    },
    // Safely toggle a class.
    toggleClass: function (target, className, force) {
        if (target) target.classList.toggle(className, force);
    },
    // Safely toggle a body class.
    toggleBodyClass: function (className, force) {
        if (document.body) document.body.classList.toggle(className, force);
    },
    // Safely set link href.
    setHref: function (target, value) {
        if (target) target.href = value || "#";
    },
    // Safely set image src.
    setSrc: function (target, value) {
        if (target) target.src = value || "";
    },
    // Safely set a background image.
    setBackgroundImage: function (target, imageUrl) {
        if (!target) return;
        target.style["background-image"] = imageUrl ? "url(" + imageUrl + ")" : "";
    },
    // Format price through the theme helper.
    formatPrice: function (price) {
        return window.Boulies && window.Boulies.formatPrice ? window.Boulies.formatPrice(price) : price;
    },
};

var chairPageData = chairUtils.getJSONScript("bt51-product-page-data", {
    amazonLinks: {},
    colorImages: {},
    upholsteryImages: {},
    hasMaterialComparison: false,
});
chairPageData.amazonLinks = chairPageData.amazonLinks || {};
chairPageData.colorImages = chairPageData.colorImages || {};
chairPageData.upholsteryImages = chairPageData.upholsteryImages || {};
chairPageData.hasMaterialComparison = chairPageData.hasMaterialComparison === true;

/* ---  product functions --- */
var productInter = {
    isAddingToCart: false,
    warrantyAddonHandle: "",
    warrantyAddonVariantId: "",
    // Keep desktop and mobile add-to-cart buttons in the same request state.
    setAddToCartLoading: function (isLoading) {
        var buttons = [document.getElementById("bt20-csb_cartBtn"), document.getElementById("bt51-mobileStickyCartBtn")],
            seenButtons = [];

        productInter.isAddingToCart = isLoading;
        buttons.forEach(function (button) {
            if (!button || seenButtons.indexOf(button) > -1) return;
            seenButtons.push(button);
            button.classList.toggle("bt20-csb_addingItem", isLoading);
            button.disabled = isLoading || button.classList.contains("bt32-csb_preorderClosed");
        });
    },
    // Build cart payload and submit the selected chair plus addons.
    addToCart: function (target) {
        if (!target || target.disabled || productInter.isAddingToCart) return false;
        var cartForm = document.querySelector('form[action="/cart/add"]');
        if (!cartForm) return false;

        var chairData = new FormData(cartForm);
        // create main item data
        var itemsData = {
            items: [
                {
                    id: chairData.get("id"),
                    quantity: chairData.get("quantity"),
                    properties: {
                        warranty: chairData.get("properties[warranty]"),
                        accessories: chairData.get("properties[accessories]"),
                    },
                },
            ],
        };

        if (chairData.get("properties[Estimated_to_ship_out]")) {
            itemsData.items[0].properties["Estimated_to_ship_out"] = chairData.get("properties[Estimated_to_ship_out]");
        }

        // set cart discount attributes
        var attributesData = {
            attributes: {
                cart_discount_code: "",
                cart_discount_amount: "",
            },
        };
        var mainPromotion = document.getElementById("bt34-mainPromotion");
        if (mainPromotion && mainPromotion.style["display"] == "block") {
            attributesData.attributes["cart_discount_code"] = chairData.get("attributes[cart_discount_code]");
            attributesData.attributes["cart_discount_amount"] = chairData.get("attributes[cart_discount_amount]");
        }
        var hasCartDiscountAttributes = attributesData.attributes["cart_discount_code"] || attributesData.attributes["cart_discount_amount"];

        if (productInter.isWarrantyAddonSelected() && productInter.warrantyAddonVariantId) {
            itemsData.items.push({
                id: productInter.warrantyAddonVariantId,
                quantity: 1,
            });
        }

        $.ajax({
            type: "POST",
            dataType: "JSON",
            url: "/cart/add.js",
            data: itemsData,
            timeout: 8000,
            // Update cart drawer after the add-to-cart request succeeds.
            success: function () {
                var refreshCartRequest = hasCartDiscountAttributes
                    ? $.ajax({
                          type: "POST",
                          url: "/cart/update.js",
                          data: attributesData,
                          dataType: "JSON",
                          timeout: 8000,
                      })
                    : $.ajax({
                          type: "GET",
                          url: "/cart.js",
                          dataType: "JSON",
                          timeout: 8000,
                      });

                refreshCartRequest
                    .done(function (cartData) {
                        ajaxcart.updateCartItem(cartData);
                        ajaxcart.openCart();
                    })
                    .fail(function () {
                        ajaxcart.openCart();
                    })
                    .always(function () {
                        productInter.setAddToCartLoading(false);
                    });
                // rdt('track', 'AddToCart');
                var current_option = document.querySelector('input[value="' + chairData.get("id") + '"]');
            },
            // Restore button state when add-to-cart fails.
            error: function (err) {
                productInter.setAddToCartLoading(false);
                var isNetworkGuardError = err && (err.status == 403 || err.status == 429 || err.statusText == "timeout");
                alert(isNetworkGuardError ? "アクセスが集中しています。時間をおいて再度お試しください。" : err?.responseJSON?.description || err?.responseJSON?.message || "カートへの追加に失敗しました。時間をおいて再度お試しください。");
            },
            // Show add-to-cart loading state before submit.
            beforeSend: function () {
                productInter.setAddToCartLoading(true);
            },
        });
    },
    // Render pre-order wave progress for the selected variant.
    updatePreOrderInfo: function (data, quantity) {
        var preOrderInfoWrap = document.querySelector(".bt20-csb_preOrderWrap");
        if (!preOrderInfoWrap) return;
        if (!Array.isArray(data) || data.length == 0) {
            preOrderInfoWrap.innerHTML = "";
            return;
        }

        var tempDOM = "";
        for (var i = 0; i < data.length - 1; i++) {
            tempDOM +=
                '<div class="bt20-csb_preOrderWaves"><div class="bt20-csb_preOrderInfo"><span class="bt20-csb_wave">' +
                // delete waves count
                (i + 1) +
                '</span><span class="bt20-csb_etsDate">' +
                data[i].ets +
                "</span></div></div>";
        }
        tempDOM +=
            '<div class="bt20-csb_preOrderWaves bt20-csb_currentWave"><div class="bt20-csb_preOrderInfo"><span class="bt20-csb_wave">' +
            // delete waves count
            data.length +
            '</span><span class="bt20-csb_etsDate">' +
            data[data.length - 1].ets +
            '</span></div><div class="bt20-csb_preOrderedStatus"><div class="bt20-csb_preOrderedDone" id="bt36-csb_preOrderProgress"></div></div></div>';
        preOrderInfoWrap.innerHTML = tempDOM;
        var totalNumber = parseInt(data[data.length - 1].total_number, 10),
            selectedQuantity = parseInt(quantity, 10),
            orderStatus = totalNumber > 0 ? Math.round(((totalNumber - selectedQuantity) / totalNumber) * 100) + "%" : "0%";
        setTimeout(function () {
            var progress = document.getElementById("bt36-csb_preOrderProgress");
            if (!progress) return;
            progress.textContent = orderStatus;
            progress.style.width = orderStatus;
        }, 1000);
    },
    saleCodeScrollTimer: null,
    saleCodeScrollDelay: null,
    // Auto-scroll long sale code text when it overflows.
    initSaleCodeAutoScroll: function () {
        var saleCodeInfo = document.querySelector(".bps_saleCodeInfo");
        if (!saleCodeInfo) return;

        clearInterval(productInter.saleCodeScrollTimer);
        clearTimeout(productInter.saleCodeScrollDelay);
        productInter.saleCodeScrollTimer = null;
        productInter.saleCodeScrollDelay = null;
        saleCodeInfo.scrollLeft = 0;
        saleCodeInfo.classList.remove("bps_saleCodeInfo--scrolling");

        if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        productInter.saleCodeScrollDelay = setTimeout(function () {
            var maxScrollLeft = saleCodeInfo.scrollWidth - saleCodeInfo.clientWidth;
            if (maxScrollLeft <= 1) return;

            var direction = 1;
            var pauseTicks = 18;
            saleCodeInfo.classList.add("bps_saleCodeInfo--scrolling");
            productInter.saleCodeScrollTimer = setInterval(function () {
                if (pauseTicks > 0) {
                    pauseTicks--;
                    return;
                }

                saleCodeInfo.scrollLeft += direction;

                if (saleCodeInfo.scrollLeft >= maxScrollLeft) {
                    direction = -1;
                    pauseTicks = 18;
                } else if (saleCodeInfo.scrollLeft <= 0) {
                    direction = 1;
                    pauseTicks = 18;
                }
            }, 40);
        }, 150);
    },
    galleryImagesByKey: null,
    currentGalleryImageKey: null,
    galleryUpdateRequestId: 0,
    // Escape text before interpolating into generated HTML.
    escapeHtml: function (value) {
        return String(value == null ? "" : value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    },
    // Group gallery images by variant image key from the JSON data block.
    getGalleryImagesByKey: function () {
        if (productInter.galleryImagesByKey) return productInter.galleryImagesByKey;

        var galleryData = document.getElementById("bt51-product-gallery-data"),
            imageList = [];

        productInter.galleryImagesByKey = {};
        if (!galleryData) return productInter.galleryImagesByKey;

        imageList = chairUtils.parseJSON(galleryData.textContent || "[]", []);

        imageList.forEach(function (image) {
            if (!image.imageKey) return;
            if (!productInter.galleryImagesByKey[image.imageKey]) {
                productInter.galleryImagesByKey[image.imageKey] = [];
            }
            productInter.galleryImagesByKey[image.imageKey].push(image);
        });

        return productInter.galleryImagesByKey;
    },
    // Return all gallery images for one variant key.
    getVariantGalleryImages: function (imageKey) {
        return productInter.getGalleryImagesByKey()[imageKey] || [];
    },
    // Return the first gallery image used as an option preview.
    getVariantPreviewImage: function (imageKey) {
        var images = productInter.getVariantGalleryImages(imageKey);
        return images.length ? images[0] : null;
    },
    // Keep thumbnail count aligned with available gallery images.
    getGalleryListSlidesToShow: function (imageCount) {
        if (imageCount <= 1) return 1;
        return Math.min(5, imageCount - 1);
    },
    // Update slick thumbnail settings when gallery image count changes.
    updateGalleryListSlickOptions: function (imageCount) {
        var slidesToShow = productInter.getGalleryListSlidesToShow(imageCount),
            responsive = [
                {
                    breakpoint: 1280,
                    settings: {
                        vertical: false,
                        verticalSwiping: false,
                        slidesToShow: slidesToShow,
                        centerMode: true,
                    },
                },
            ],
            slickInstance = collectionGalleryList.slick("getSlick");

        slickInstance.originalSettings.slidesToShow = slidesToShow;
        slickInstance.originalSettings.responsive = responsive;
        collectionGalleryList.slick(
            "slickSetOption",
            {
                slidesToShow: slidesToShow,
                responsive: responsive,
            },
            true,
        );
    },
    // Toggle the gallery loading visual state.
    setProductGalleryLoading: function (isLoading) {
        var galleryBox = document.querySelector(".bt20-csb_imageBox");
        if (!galleryBox) return;
        galleryBox.classList.toggle("bt51-gallery-loading", isLoading);
    },
    // Preload the first gallery image before swapping an existing gallery.
    preloadProductGalleryFirstImage: function (galleryImages, callback) {
        var firstImage = galleryImages.length ? galleryImages[0] : null,
            preloadSrc = firstImage && window.devicePixelRatio > 1 && firstImage.main2x ? firstImage.main2x : firstImage ? firstImage.main || firstImage.src : "",
            preloadImage,
            preloadTimer,
            isDone = false,
            done = function () {
                if (isDone) return;
                isDone = true;
                clearTimeout(preloadTimer);
                callback();
            };

        if (!preloadSrc) {
            callback();
            return;
        }

        preloadImage = new Image();
        preloadTimer = setTimeout(done, 900);
        preloadImage.onload = done;
        preloadImage.onerror = done;
        preloadImage.src = preloadSrc;

        if (preloadImage.complete) done();
    },
    // Replace slick slides with the selected variant gallery.
    renderProductGallery: function (galleryImages, imageKey) {
        var mainSlideCount = collectionGallery.slick("getSlick").slideCount,
            thumbSlideCount = collectionGalleryList.slick("getSlick").slideCount;

        for (var i = mainSlideCount - 1; i >= 0; i--) {
            collectionGallery.slick("slickRemove", i);
        }
        for (var n = thumbSlideCount - 1; n >= 0; n--) {
            collectionGalleryList.slick("slickRemove", n);
        }

        productInter.updateGalleryListSlickOptions(galleryImages.length);

        galleryImages.forEach(function (image, index) {
            var originalImage = image.src || image.main || "",
                mainImage = image.main || Boulies.imageResize(originalImage, 640),
                main2xImage = image.main2x || Boulies.imageResize(originalImage, 1280),
                thumbImage = image.thumb || Boulies.imageResize(originalImage, 180),
                altText = productInter.escapeHtml(image.alt || ""),
                imageWidth = image.width || 1280,
                imageHeight = image.height || 1280,
                mainLoading = index == 0 ? "eager" : "lazy",
                mainPriority = index == 0 ? ' fetchpriority="high"' : "";

            collectionGallery.slick("slickAdd", '<a class="pswp_image" href="' + originalImage + '" data-lg-size="' + imageWidth + "-" + imageHeight + '" target="_blank"><img class="bt32-collectionGalleryItem" src="' + mainImage + '" srcset="' + mainImage + " 1x, " + main2xImage + ' 2x" sizes="(max-width: 650px) 100vw, 640px" alt="' + altText + '" width="640" height="640" loading="' + mainLoading + '" decoding="async"' + mainPriority + "></a>");
            collectionGalleryList.slick("slickAdd", '<div><img src="' + thumbImage + '" alt="' + altText + '" width="60" height="60" loading="lazy" decoding="async"></div>');
        });

        if (galleryImages.length > 0) {
            collectionGallery.slick("slickGoTo", 0, true);
            collectionGalleryList.slick("slickGoTo", 0, true);
            collectionGallery.slick("setPosition");
            collectionGalleryList.slick("setPosition");
        }
        productInter.currentGalleryImageKey = imageKey;
    },
    // Refresh the gallery for the selected variant.
    updateProductGallery: function (imageKey) {
        var galleryImages = productInter.getVariantGalleryImages(imageKey),
            mainSlideCount = collectionGallery.slick("getSlick").slideCount,
            hasCurrentGallery = mainSlideCount > 0,
            requestId;

        productInter.galleryUpdateRequestId++;
        requestId = productInter.galleryUpdateRequestId;

        if (productInter.currentGalleryImageKey == imageKey && mainSlideCount > 0) {
            productInter.setProductGalleryLoading(false);
            return;
        }

        if (!hasCurrentGallery) {
            productInter.renderProductGallery(galleryImages, imageKey);
            return;
        }

        productInter.setProductGalleryLoading(true);
        productInter.preloadProductGalleryFirstImage(galleryImages, function () {
            if (requestId != productInter.galleryUpdateRequestId) return;

            productInter.renderProductGallery(galleryImages, imageKey);
            (window.requestAnimationFrame || window.setTimeout)(function () {
                if (requestId == productInter.galleryUpdateRequestId) {
                    productInter.setProductGalleryLoading(false);
                }
            });
        });
    },
    // Read selected variant metadata from its data attribute.
    getVariantMetadata: function (variantInput) {
        if (!variantInput || !variantInput.dataset || !variantInput.dataset.variantMetadata || variantInput.dataset.variantMetadata == "null") return {};
        return chairUtils.parseJSON(variantInput.dataset.variantMetadata, {}) || {};
    },
    // Return pre-order data with a stable fallback shape.
    getPreOrderData: function (metadata) {
        return (metadata && metadata.pre_order) || {};
    },
    // Return pre-order waves only when the metadata contains an array.
    getPreOrderWaves: function (metadata) {
        var waves = productInter.getPreOrderData(metadata).waves;
        return Array.isArray(waves) ? waves : [];
    },
    // Determine whether the selected variant is currently pre-order.
    isPreOrderVariant: function (metadata) {
        return productInter.getPreOrderData(metadata).status == true;
    },
    // Read URL params through the theme helper without assuming it always exists.
    getUrlParams: function () {
        if (!window.Boulies || !window.Boulies.getUrlkey) return {};
        return window.Boulies.getUrlkey() || {};
    },
    // Push the selected variant into the product URL.
    updateProductUrl: function (current_variant) {
        var currentSearch = productInter.getUrlParams(),
            query = "?";

        if (!current_variant || !current_variant.value) return;
        currentSearch["variant"] = current_variant.value;

        for (var key in currentSearch) {
            if (!Object.prototype.hasOwnProperty.call(currentSearch, key)) continue;
            query += encodeURIComponent(key) + "=" + encodeURIComponent(currentSearch[key]) + "&";
        }

        history.pushState({}, "", query.substr(0, query.length - 1));
    },
    // Update hidden line item properties for cart submission.
    updateProductProperties: function (metadata) {
        var warrantyMonths = metadata && metadata.warranty,
            warrantyText = warrantyMonths ? "保証期間 " + warrantyMonths + "ヶ月保証" : "",
            preOrderInput = document.getElementById("itemProperties_preOrderDescription"),
            waves = productInter.getPreOrderWaves(metadata),
            lastWave = waves.length ? waves[waves.length - 1] : null;

        chairUtils.setValue(document.getElementById("itemProperties_warranty"), warrantyText);
        chairUtils.setValue(document.getElementById("itemProperties_accessories"), metadata ? metadata.accessories : "");

        if (preOrderInput && productInter.isPreOrderVariant(metadata) && lastWave && lastWave.ets) {
            preOrderInput.disabled = false;
            preOrderInput.value = "出荷予定日" + lastWave.ets;
        } else {
            chairUtils.setDisabled(preOrderInput, true);
            chairUtils.setValue(preOrderInput, "");
        }
    },
    // Toggle shipping/service snippets based on pre-order status.
    updateShippingInfo: function (metadata) {
        var isPreOrder = productInter.isPreOrderVariant(metadata),
            shippingTime = document.getElementById("bt40-csb_shipping-time"),
            serviceSameDay = document.getElementById("bt51-serviceSameDay");

        chairUtils.setDisplay(shippingTime, isPreOrder ? "none" : "flex");
        chairUtils.setDisplay(serviceSameDay, isPreOrder ? "none" : "");
    },
    // Update cart, inventory, and notify-me UI for the selected variant.
    updateAvailabilityState: function (current_variant, metadata) {
        var cart = document.querySelector(".bt20-csb_cart"),
            notifymeContainer = document.querySelector(".bt32-notifymeContainer"),
            cartBtn = document.getElementById("bt20-csb_cartBtn"),
            inventory = document.querySelector(".bt20-csb_inventory"),
            shippingInfo = document.querySelector(".bt20-csb_shippingInfo"),
            serviceSameDay = document.getElementById("bt51-serviceSameDay"),
            isAvailable = current_variant && current_variant.dataset.available == "true",
            isPreOrder = productInter.isPreOrderVariant(metadata),
            preOrderWaves = productInter.getPreOrderWaves(metadata);

        if (isAvailable) {
            chairUtils.setDisplay(cart, "block");
            chairUtils.setDisplay(notifymeContainer, "none");
            chairUtils.toggleBodyClass("bt51-restock-rocket-visible", false);
            chairUtils.setDisplay(shippingInfo, "block");

            if (isPreOrder) {
                chairUtils.toggleClass(cart, "bt20-csb_proOrdering", preOrderWaves.length > 0);
                if (cartBtn) {
                    cartBtn.classList.remove("bt20-csb_activeCartBtn", "bt20-csb_addingItem", "bt32-csb_preorderClosed");
                    cartBtn.classList.add("bt20-csb_preorderCartBtn");
                    cartBtn.disabled = false;
                }
                if (inventory) inventory.classList.remove("bt20-csb_inStock", "bt20-csb_outOfStock");
                productInter.updatePreOrderInfo(preOrderWaves, current_variant.dataset.quantity);
            } else {
                if (cartBtn) {
                    cartBtn.classList.remove("bt20-csb_preorderCartBtn", "bt20-csb_addingItem", "bt32-csb_preorderClosed");
                    cartBtn.classList.add("bt20-csb_activeCartBtn");
                    cartBtn.disabled = false;
                }
                if (inventory) {
                    inventory.classList.remove("bt20-csb_outOfStock");
                    inventory.classList.add("bt20-csb_inStock");
                }
                chairUtils.toggleClass(cart, "bt20-csb_proOrdering", false);
            }
            return;
        }

        var notifymeData = document.getElementById("bt32-notifyme_data");
        if (inventory) {
            inventory.classList.remove("bt20-csb_inStock");
            inventory.classList.add("bt20-csb_outOfStock");
        }
        chairUtils.setDisplay(shippingInfo, "none");
        chairUtils.setDisplay(cart, "none");
        chairUtils.setDisplay(serviceSameDay, "none");
        if (notifymeData && current_variant) {
            notifymeData.dataset.region = window.Boulies && window.Boulies.setting ? window.Boulies.setting.region : "";
            notifymeData.dataset.itemName = current_variant.dataset.productSeries || "";
            notifymeData.dataset.itemColor = current_variant.dataset.options || [current_variant.dataset.option2, current_variant.dataset.option3].filter(Boolean).join(" / ");
            notifymeData.dataset.itemSku = current_variant.id || current_variant.value || "";
        }
        chairUtils.setDisplay(notifymeContainer, "block");
        chairUtils.toggleBodyClass("bt51-restock-rocket-visible", true);
    },
    // Update Amazon purchase link and optional sale badge.
    updateAmazonLink: function (current_variant) {
        var amazonInfo = current_variant && current_variant.value ? chairPageData.amazonLinks[current_variant.value] : null,
            amazonPurchaseLinkBtn = document.getElementById("amazonPurchaseLink"),
            amazonSalebadge = document.getElementById("amazonSalebadge");

        if (!amazonPurchaseLinkBtn) return;

        if (amazonInfo && amazonInfo.link) {
            chairUtils.setDisplay(amazonPurchaseLinkBtn, "flex");
            chairUtils.setHref(amazonPurchaseLinkBtn, amazonInfo.link);

            if (amazonSalebadge && amazonInfo.text) {
                chairUtils.setDisplay(amazonSalebadge, "block");
                chairUtils.setText(amazonSalebadge, amazonInfo.text);
            } else {
                chairUtils.setDisplay(amazonSalebadge, "none");
                chairUtils.setText(amazonSalebadge, "");
            }
            return;
        }

        chairUtils.setDisplay(amazonPurchaseLinkBtn, "none");
        chairUtils.setHref(amazonPurchaseLinkBtn, "#");
        chairUtils.setDisplay(amazonSalebadge, "none");
        chairUtils.setText(amazonSalebadge, "");
    },
    // Update main promotion text, discount attributes, and visible price.
    updatePromotionDisplay: function (current_variant, metadata) {
        var saleWrap = document.getElementById("bt34-mainPromotion"),
            pricesWrap = document.getElementById("bt20-csb_pricesWrap"),
            mainPromotion = (metadata && metadata.Main_Promotion) || {},
            variantPrice = parseInt(current_variant && current_variant.dataset.price, 10) || 0,
            discount = parseInt(mainPromotion.discount, 10) || 0;

        if (current_variant && current_variant.dataset.saleStatus == "true") {
            chairUtils.setText(document.getElementById("bt20-saleName"), mainPromotion.name || "");
            chairUtils.setText(document.getElementById("bt20-saleCode"), mainPromotion.code || "");
            chairUtils.setBackgroundImage(document.getElementById("bps_saleBannerBg"), mainPromotion.image || "");
            chairUtils.setText(document.getElementById("bt20-saleDiscount"), discount / 100);
            chairUtils.setValue(document.getElementById("cart_discount_code"), mainPromotion.code || "");
            chairUtils.setValue(document.getElementById("cart_discount_amount"), discount / 100);
            chairUtils.setDisplay(saleWrap, "block");
            chairUtils.setText(document.getElementById("b5-collection__old_price"), chairUtils.formatPrice(variantPrice));
            chairUtils.setText(document.getElementById("bt20-collection_price"), chairUtils.formatPrice(variantPrice - discount));
            chairUtils.toggleClass(pricesWrap, "b5-on-sale-price", true);
        } else {
            chairUtils.setDisplay(saleWrap, "none");
            chairUtils.toggleClass(pricesWrap, "b5-on-sale-price", false);
            chairUtils.setText(document.getElementById("bt20-collection_price"), chairUtils.formatPrice(variantPrice));
        }

        productInter.initSaleCodeAutoScroll();
    },
    // Update secondary promotion banner when the date window is active.
    updateSubPromotionDisplay: function (metadata) {
        var subPromotion = (metadata && metadata.Sub_Promotion) || {},
            subPromotionWrap = document.querySelector(".product_sub_promotion_wrapper__bt40"),
            startDate = new Date(subPromotion.start).getTime(),
            endDate = new Date(subPromotion.end).getTime(),
            localDate = new Date().getTime(),
            isActive = !isNaN(startDate) && !isNaN(endDate) && endDate > localDate && startDate < localDate;

        if (isActive) {
            chairUtils.setHref(document.getElementById("sub_promotion_url__bt40"), subPromotion.url || "#");
            chairUtils.setSrc(document.getElementById("sub_promotion_image__bt40"), subPromotion.image || "");
            chairUtils.setDisplay(subPromotionWrap, "block");
        } else {
            chairUtils.setDisplay(subPromotionWrap, "none");
        }
    },
    // Coordinate all UI updates for the selected variant.
    changeToThisOption: function (current_variant, stopPopstate, stopKlarnaReflash) {
        if (!current_variant) return;

        var currentVariantMetadata = productInter.getVariantMetadata(current_variant);

        productInter.updateProductGallery(current_variant.id);
        if (!stopPopstate) productInter.updateProductUrl(current_variant);
        productInter.updateProductSubtitle(current_variant);
        productInter.updateProductProperties(currentVariantMetadata);
        productInter.updateShippingInfo(currentVariantMetadata);
        productInter.updateAvailabilityState(current_variant, currentVariantMetadata);
        productInter.getAddonItems(currentVariantMetadata.addon);
        productInter.updateAmazonLink(current_variant);
        productInter.updatePromotionDisplay(current_variant, currentVariantMetadata);
        productInter.updateSubPromotionDisplay(currentVariantMetadata);
        productInter.syncMobileStickyPurchaseBar();
    },
    variantsMap: {},
    // Build model/upholstery/color lookup from variant inputs.
    makeVariantsMap: function () {
        var modelListNode = document.querySelector("#product-model-list"),
            model_list = modelListNode ? chairUtils.parseJSON(modelListNode.dataset.list, []) : [];

        productInter.variantsMap = {};
        if (!Array.isArray(model_list)) model_list = [];

        model_list.forEach(function (model) {
            productInter.variantsMap[model] = {};
        });

        document.querySelectorAll(".bt51-variant").forEach(function (variant) {
            var option1 = variant.dataset.option1,
                option2 = variant.dataset.option2,
                final_price = variant.dataset.saleStatus == "true" ? parseInt(variant.dataset.price, 10) - (parseInt(variant.dataset.saleDiscount, 10) || 0) : parseInt(variant.dataset.price, 10);

            if (!option1 || !option2) return;
            if (!productInter.variantsMap[option1]) productInter.variantsMap[option1] = {};
            if (productInter.variantsMap[option1][option2] === undefined) {
                productInter.variantsMap[option1][option2] = [];
            }

            productInter.variantsMap[option1][option2].push({
                sku: variant.id,
                price: isNaN(final_price) ? 0 : final_price,
                model: option1,
                upholstery: option2,
                color: variant.dataset.option3,
            });
        });
    },
    // Render model and upholstery option controls on first load.
    sortOptionsOnFirstLoad: function () {
        var models = Object.keys(productInter.variantsMap),
            upholsterys = [],
            models_HTML = "",
            upholsterys_HTML = "",
            default_variant = document.querySelector("input.bt51-variant:checked"),
            default_model,
            default_upholstery,
            productModelList = document.getElementById("product-model-list");

        if (default_variant) {
            default_model = default_variant.dataset.option1;
            default_upholstery = default_variant.dataset.option2;
        } else {
            var variants = document.querySelectorAll("input.bt51-variant"),
                default_option = productModelList && productModelList.dataset.defaultOption ? productModelList.dataset.defaultOption.split(" / ") : [],
                weighted_variants = [];

            if (!variants.length) return;

            for (var i = 0; i < variants.length; i++) {
                if (variants[i].dataset.option1 == default_option[0] && variants[i].dataset.option2 == default_option[1]) {
                    weighted_variants.push({
                        node: variants[i],
                        weight: 2,
                    });
                } else if (variants[i].dataset.option1 == default_option[0]) {
                    weighted_variants.push({
                        node: variants[i],
                        weight: 1,
                    });
                } else {
                    weighted_variants.push({
                        node: variants[i],
                        weight: 0,
                    });
                }
            }
            weighted_variants.sort(function (a, b) {
                return b.weight - a.weight;
            });
            weighted_variants[0].node.checked = true;
            default_model = weighted_variants[0].node.dataset.option1;
            default_upholstery = weighted_variants[0].node.dataset.option2;
        }

        for (var i = 0; i < models.length; i++) {
            var model_upholsterys = Object.keys(productInter.variantsMap[models[i]]);
            if (model_upholsterys.length == 0) continue;
            var is_checked = "";
            for (var n = 0; n < model_upholsterys.length; n++) {
                if (upholsterys.indexOf(model_upholsterys[n]) !== -1) continue;
                upholsterys.push(model_upholsterys[n]);
            }
            if (models[i] == default_model) {
                is_checked = 'checked="checked"';
            }
            models_HTML += '<input type="radio" ' + is_checked + ' class="bt51-model" name="product-model" id="bt51-model-' + i + '" value="' + productInter.escapeHtml(models[i]) + '"> <label for="bt51-model-' + i + '" class="bt51-model-display" data-value="' + productInter.escapeHtml(models[i]) + '"><span class="bt51-model-name">' + productInter.escapeHtml(models[i]) + "</span></label>";
        }

        for (var i = 0; i < upholsterys.length; i++) {
            var upholstery_preview = "",
                upholsteryImage = chairPageData.upholsteryImages[upholsterys[i]],
                is_checked = "";
            if (upholsteryImage) {
                upholstery_preview = 'style="background-image:url(' + productInter.escapeHtml(upholsteryImage) + ')"';
            }
            if (upholsterys[i] == default_upholstery) {
                is_checked = 'checked="checked"';
            }
            upholsterys_HTML += '<input type="radio" ' + is_checked + ' class="bt51-upholstery" name="product-upholstery" id="bt51-upholstery-' + i + '" value="' + productInter.escapeHtml(upholsterys[i]) + '"> <label for="bt51-upholstery-' + i + '" class="bt51-upholstery-display" data-value="' + productInter.escapeHtml(upholsterys[i]) + '" ' + upholstery_preview + '><span class="bt51-upholstery-name">' + productInter.escapeHtml(upholsterys[i]) + "</span></label>";
        }

        if (productModelList) productModelList.innerHTML = models_HTML;
        var upholsteryList = document.getElementById("product-upholstery-list");
        if (upholsteryList) upholsteryList.innerHTML = upholsterys_HTML;
    },
    // Sync upholstery options after model changes.
    changeUpholstery: function (stop_active_first_element) {
        var checkedModel = document.querySelector("input.bt51-model:checked");
        if (!checkedModel) return;

        var model_value = checkedModel.value,
            modelOptions = productInter.variantsMap[model_value] || {},
            upholstery_input = document.querySelectorAll(".bt51-upholstery");

        document.querySelectorAll(".bt51-upholstery-display").forEach(function (upholstery, index) {
            if (modelOptions[upholstery.dataset.value] === undefined) {
                upholstery.style.display = "none";
                if (upholstery_input[index]) upholstery_input[index].disabled = true;
            } else {
                upholstery.style.display = "block";
                if (upholstery_input[index]) upholstery_input[index].disabled = false;
            }
        });
        if (!stop_active_first_element) {
            var firstEnabledUpholstery = document.querySelector("input.bt51-upholstery:enabled");
            if (firstEnabledUpholstery) firstEnabledUpholstery.checked = true;
            productInter.changeVariants(stop_active_first_element);
        } else {
            productInter.changeVariants(stop_active_first_element);
        }
        productInter.refreshOptionDropdowns();
    },
    // Sync visible color variants after upholstery changes.
    changeVariants: function (stop_active_first_element) {
        var checkedModel = document.querySelector('input[name="product-model"]:checked'),
            checkedUpholstery = document.querySelector('input[name="product-upholstery"]:checked');
        if (!checkedModel || !checkedUpholstery) return;

        var model_value = checkedModel.value;
        var upholstery_value = checkedUpholstery.value;
        var variant_input = document.querySelectorAll(".bt51-variant");
        document.querySelectorAll(".bt51-variant-display").forEach(function (variant, index) {
            if (variant.dataset.option1 == model_value && variant.dataset.option2 == upholstery_value) {
                variant.style.display = "block";
                if (variant_input[index]) variant_input[index].disabled = false;
            } else {
                variant.style.display = "none";
                if (variant_input[index]) variant_input[index].disabled = true;
            }
        });
        if (!stop_active_first_element) {
            var firstEnabledVariant = document.querySelector("input.bt51-variant:enabled");
            if (firstEnabledVariant) firstEnabledVariant.checked = true;
            productInter.changeToThisOption(document.querySelector('input[name="id"]:checked'));
        } else {
            productInter.changeToThisOption(document.querySelector('input[name="id"]:checked'), false, stop_active_first_element);
        }
        productInter.refreshOptionDropdowns();
    },
    // Sync dropdown trigger text and expanded state.
    syncOptionDropdown: function (section) {
        if (!section) return;
        var trigger = section.querySelector(".bt51-option-dropdown__trigger");
        if (!trigger) return;

        var currentText = trigger.querySelector(".bt51-option-dropdown__current");
        if (!currentText) {
            currentText = document.createElement("span");
            currentText.className = "bt51-option-dropdown__current";
            trigger.appendChild(currentText);
        }

        var checkedInput = section.querySelector("input:checked"),
            checkedLabel = checkedInput ? checkedInput.nextElementSibling : null,
            nameNode = checkedLabel ? checkedLabel.querySelector(".bt51-model-name, .bt51-upholstery-name, .bt51-warranty-option-name") : null;

        if (nameNode && nameNode.classList.contains("bt51-warranty-option-name") && nameNode.children.length) {
            currentText.textContent = "";
            Array.prototype.slice.call(nameNode.children).forEach(function (child) {
                currentText.appendChild(child.cloneNode(true));
            });
        } else {
            currentText.textContent = (nameNode ? nameNode.textContent : checkedInput ? checkedInput.value : "").trim();
        }

        trigger.setAttribute("aria-expanded", section.classList.contains("bt51-option-dropdown--open") ? "true" : "false");
    },
    // Close all option dropdowns except the provided section.
    closeOptionDropdowns: function (exceptSection) {
        document.querySelectorAll(".bt51-option-dropdown--open").forEach(function (section) {
            if (section === exceptSection) return;
            section.classList.remove("bt51-option-dropdown--open");
            productInter.syncOptionDropdown(section);
        });
    },
    // Open a single option dropdown when it is selectable.
    openOptionDropdown: function (section) {
        if (!section || section.classList.contains("bt51-product-section--hidden") || section.classList.contains("bt51-option-dropdown--single")) return;
        productInter.closeOptionDropdowns(section);
        section.classList.add("bt51-option-dropdown--open");
        productInter.syncOptionDropdown(section);
    },
    // Refresh dropdown visibility and current labels.
    refreshOptionDropdowns: function () {
        var modelSection = document.querySelector(".bt51-product-section--model");
        if (modelSection) {
            var modelInputs = modelSection.querySelectorAll("input.bt51-model"),
                hasSingleModel = modelInputs.length <= 1,
                modelTrigger = modelSection.querySelector(".bt51-option-dropdown__trigger");

            modelSection.classList.toggle("bt51-product-section--hidden", hasSingleModel);
            modelSection.classList.toggle("bt51-option-dropdown--single", hasSingleModel);

            if (hasSingleModel) {
                modelSection.classList.remove("bt51-option-dropdown--open");
            }

            if (modelTrigger) {
                modelTrigger.setAttribute("aria-disabled", hasSingleModel ? "true" : "false");
            }
        }

        document.querySelectorAll(".bt51-option-dropdown").forEach(function (section) {
            var enabledInputs = Array.prototype.filter.call(section.querySelectorAll("input"), function (input) {
                return !input.disabled;
            });
            section.classList.toggle("bt51-option-dropdown--one-option", enabledInputs.length <= 1);
            productInter.syncOptionDropdown(section);
        });
    },
    // Initialize option dropdown triggers and close handlers.
    setupOptionDropdowns: function () {
        document.querySelectorAll(".bt51-product-section--model, .bt51-product-section--upholstery, .bt51-product-section--warranty").forEach(function (section) {
            section.classList.add("bt51-option-dropdown");

            var fieldset = section.querySelector("fieldset"),
                trigger = section.querySelector(".bt51-option-dropdown__trigger");

            if (!trigger) {
                trigger = document.createElement("button");
                trigger.type = "button";
                trigger.className = "bt51-option-dropdown__trigger";
                trigger.innerHTML = '<span class="bt51-option-dropdown__current"></span>';
                section.insertBefore(trigger, fieldset || null);
            }

            if (fieldset && fieldset.id) {
                trigger.setAttribute("aria-controls", fieldset.id);
            }
            trigger.setAttribute("aria-expanded", "false");
            trigger.addEventListener("click", function () {
                if (section.classList.contains("bt51-option-dropdown--single")) return;

                if (section.classList.contains("bt51-option-dropdown--open")) {
                    productInter.closeOptionDropdowns();
                } else {
                    productInter.openOptionDropdown(section);
                }
            });

            if (fieldset) {
                fieldset.setAttribute("tabindex", "0");
            }

            if (chairPageData.hasMaterialComparison && section.classList.contains("bt51-product-section--upholstery") && fieldset && !fieldset.querySelector(".bt51-material-compare-link")) {
                var materialCompareLink = document.createElement("a");
                materialCompareLink.className = "bt51-material-compare-link";
                materialCompareLink.href = "#productMaterialModal";
                materialCompareLink.setAttribute("role", "button");
                materialCompareLink.setAttribute("aria-haspopup", "dialog");
                materialCompareLink.setAttribute("aria-controls", "productMaterialModal");
                materialCompareLink.textContent = "素材比較はこちら";
                fieldset.appendChild(materialCompareLink);
            }

            if (fieldset) {
                fieldset.addEventListener("click", function (event) {
                    var target = event.target,
                        label = target.closest ? target.closest("label") : null;

                    if (target.closest && target.closest(".bt51-material-compare-link")) return;

                    if (label) {
                        setTimeout(function () {
                            productInter.refreshOptionDropdowns();
                            productInter.closeOptionDropdowns();
                        }, 0);
                    }
                });
            }
        });

        document.addEventListener("click", function (event) {
            if (event.target.closest && event.target.closest(".bt51-option-dropdown")) return;
            productInter.closeOptionDropdowns();
        });

        document.addEventListener("keydown", function (event) {
            if (event.key !== "Escape") return;
            productInter.closeOptionDropdowns();
        });

        productInter.refreshOptionDropdowns();
    },
    materialCompareLastTrigger: null,
    materialCompareOpenTimer: null,
    materialCompareCloseTimer: null,
    restockRocketModalObserver: null,
    restockRocketOpenListenerReady: false,
    // Check whether the app-injected restock modal is present.
    isRestockRocketModalOpen: function () {
        return !!document.querySelector("#restock-rocket .restock-rocket-wrapper");
    },
    // Release page scroll lock when no overlay still needs it.
    releaseMaterialCompareScrollLock: function () {
        var cartWrap = document.querySelector(".bouliesCartWrap");

        if (document.querySelector(".product-material-modal.is-active")) return;
        if (productInter.isRestockRocketModalOpen()) return;
        if (cartWrap && cartWrap.classList.contains("bouliesCartLoaded")) return;
        document.documentElement.classList.remove("bouliesNoscroll");
    },
    // Sync page scroll lock with the app-injected restock modal.
    syncRestockRocketModalState: function () {
        if (productInter.isRestockRocketModalOpen()) {
            document.documentElement.classList.add("bouliesNoscroll");
        } else {
            productInter.releaseMaterialCompareScrollLock();
        }
    },
    // Watch the app modal container without binding scroll listeners.
    initRestockRocketModalObserver: function () {
        var restockRocketRoot = document.getElementById("restock-rocket");

        if (!window.MutationObserver) return;
        if (!restockRocketRoot) {
            if (!productInter.restockRocketOpenListenerReady) {
                productInter.restockRocketOpenListenerReady = true;
                document.addEventListener("click", function (event) {
                    if (!event.target.closest || !event.target.closest(".restock-rocket-button-container, .restock-rocket-button")) return;

                    window.setTimeout(productInter.initRestockRocketModalObserver, 0);
                    window.setTimeout(productInter.initRestockRocketModalObserver, 200);
                    window.setTimeout(productInter.syncRestockRocketModalState, 300);
                });
            }
            return;
        }

        if (productInter.restockRocketModalObserver) return;

        productInter.restockRocketModalObserver = new MutationObserver(function () {
            productInter.syncRestockRocketModalState();
        });
        productInter.restockRocketModalObserver.observe(restockRocketRoot, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["class", "style"],
        });

        productInter.syncRestockRocketModalState();
    },
    // Open the material comparison modal.
    openMaterialCompareModal: function (trigger) {
        var modal = document.getElementById("productMaterialModal"),
            triggerDropdown = trigger && trigger.closest ? trigger.closest(".bt51-option-dropdown") : null,
            closeButton;

        if (!modal) return;

        window.clearTimeout(productInter.materialCompareOpenTimer);
        window.clearTimeout(productInter.materialCompareCloseTimer);
        productInter.materialCompareLastTrigger = triggerDropdown ? triggerDropdown.querySelector(".bt51-option-dropdown__trigger") : trigger || null;
        modal.style.display = "block";
        modal.setAttribute("aria-hidden", "false");
        document.documentElement.classList.add("bouliesNoscroll");

        productInter.materialCompareOpenTimer = setTimeout(function () {
            modal.classList.add("is-active");
        }, 20);

        closeButton = modal.querySelector("[data-product-material-modal-close]");
        if (closeButton && closeButton.focus) closeButton.focus({ preventScroll: true });
    },
    // Close the material comparison modal.
    closeMaterialCompareModal: function () {
        var modal = document.getElementById("productMaterialModal"),
            lastTrigger = productInter.materialCompareLastTrigger;

        if (!modal) return;

        modal.classList.remove("is-active");
        modal.setAttribute("aria-hidden", "true");
        productInter.materialCompareLastTrigger = null;
        window.clearTimeout(productInter.materialCompareOpenTimer);
        window.clearTimeout(productInter.materialCompareCloseTimer);
        productInter.materialCompareCloseTimer = setTimeout(function () {
            modal.style.display = "none";
            productInter.releaseMaterialCompareScrollLock();
        }, 500);

        if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
    },
    // Wire material comparison modal open and close interactions.
    initMaterialCompareModal: function () {
        var modal = document.getElementById("productMaterialModal");

        if (!modal) return;

        document.addEventListener("click", function (event) {
            var trigger = event.target.closest ? event.target.closest(".bt51-material-compare-link") : null;
            if (!trigger) return;

            event.preventDefault();
            productInter.closeOptionDropdowns();
            productInter.openMaterialCompareModal(trigger);
        });

        modal.addEventListener("click", function (event) {
            if (event.target === modal || (event.target.closest && event.target.closest("[data-product-material-modal-close]"))) {
                event.preventDefault();
                productInter.closeMaterialCompareModal();
            }
        });

        document.addEventListener("keydown", function (event) {
            if (event.key == "Escape" && modal.classList.contains("is-active")) {
                productInter.closeMaterialCompareModal();
            }
        });
    },
    // Update subtitle from upholstery and color options.
    updateProductSubtitle: function (current_variant) {
        var subtitle = document.getElementById("bt51-productSubtitle");
        if (!subtitle || !current_variant) return;

        var optionParts = [current_variant.dataset.option2, current_variant.dataset.option3].filter(function (option) {
            return option && option.trim();
        });
        subtitle.textContent = optionParts.join(" / ");
    },
    // Format warranty addon product price from the selected addon variant.
    formatWarrantyAddonPrice: function (item, warrantyVariant) {
        var priceRaw = warrantyVariant ? warrantyVariant.price : item && item.price,
            compareAtRaw = warrantyVariant ? warrantyVariant.compare_at_price : item && item.compare_at_price,
            priceValue = parseInt(priceRaw, 10),
            compareAtValue = parseInt(compareAtRaw, 10),
            priceData = {
                price: "",
                compareAt: "",
            };

        if (isNaN(priceValue)) return priceData;

        priceData.price = chairUtils.formatPrice(priceValue);
        if (!isNaN(compareAtValue) && compareAtValue > priceValue) {
            priceData.compareAt = chairUtils.formatPrice(compareAtValue);
        }

        return priceData;
    },
    // Render warranty addon label with optional compare-at price.
    renderWarrantyAddonOption: function (addonLabel, term, priceData) {
        var optionName = addonLabel ? addonLabel.querySelector(".bt51-warranty-option-name") : null,
            termNode,
            priceWrap,
            compareAtNode,
            currentPriceNode;

        if (!optionName) return;

        optionName.textContent = "";

        termNode = document.createElement("span");
        termNode.className = "bt51-warranty-option-term";
        termNode.textContent = term || "+1年";
        optionName.appendChild(termNode);

        if (!priceData || !priceData.price) return;

        priceWrap = document.createElement("span");
        priceWrap.className = "bt51-warranty-option-price";

        currentPriceNode = document.createElement("span");
        currentPriceNode.className = "bt51-warranty-option-current-price";
        currentPriceNode.textContent = priceData.price;
        priceWrap.appendChild(currentPriceNode);

        if (priceData.compareAt) {
            compareAtNode = document.createElement("span");
            compareAtNode.className = "bt51-warranty-option-compare-price";
            compareAtNode.textContent = priceData.compareAt;
            priceWrap.appendChild(compareAtNode);
        }

        optionName.appendChild(priceWrap);
    },
    // Choose the first available warranty addon variant.
    getWarrantyAddonVariant: function (item) {
        var variants = item && item.variants ? item.variants : [],
            fallbackVariant = variants[0];

        for (var i = 0; i < variants.length; i++) {
            if (variants[i].available !== false) return variants[i];
        }

        return fallbackVariant;
    },
    // Infer display term from warranty product text.
    getWarrantyAddonTerm: function (item, warrantyVariant, warrantyHandle) {
        var sourceText = [warrantyVariant && warrantyVariant.title, item && item.title, warrantyHandle, item && item.description].filter(Boolean).join(" "),
            yearMatch = sourceText.match(/(\d+(?:\.\d+)?)\s*(?:年|year|years|yr|yrs)/i),
            monthMatch;

        if (yearMatch) return "+" + yearMatch[1] + "年";

        monthMatch = sourceText.match(/(\d+)\s*(?:ヶ月|か月|ヵ月|カ月|months|month|mo)/i);
        if (monthMatch) {
            var months = parseInt(monthMatch[1], 10);
            if (!isNaN(months) && months % 12 === 0) return "+" + months / 12 + "年";
            return "+" + monthMatch[1] + "ヶ月";
        }

        return "+1年";
    },
    // Show or hide the warranty addon dropdown option.
    updateWarrantyAddonDisplay: function (enabled, term, priceData, selected) {
        var warrantySection = document.getElementById("bt51-warrantySection"),
            warrantyList = document.getElementById("bt51-warranty-list"),
            noneInput = document.getElementById("bt51-warranty-none"),
            addonInput = document.getElementById("bt51-warranty-addon-choice"),
            addonLabel = document.querySelector('label[for="bt51-warranty-addon-choice"]'),
            optionTerm = term || "+1年",
            optionPriceData = priceData && typeof priceData == "object" ? priceData : null,
            shouldSelectAddon = selected === true;

        if (typeof priceData == "boolean" && selected == null) {
            shouldSelectAddon = priceData;
            optionPriceData = null;
        }

        if (warrantySection) {
            warrantySection.classList.toggle("bt51-product-section--hidden", !enabled);
        }

        if (!warrantyList) return;

        if (!enabled) {
            if (addonInput) addonInput.remove();
            if (addonLabel) addonLabel.remove();
            if (noneInput) noneInput.checked = true;
            productInter.setWarrantyAddonSelected(false);
            productInter.refreshOptionDropdowns();
            return;
        }

        if (!addonInput) {
            addonInput = document.createElement("input");
            addonInput.type = "radio";
            addonInput.className = "bt51-warranty-choice";
            addonInput.name = "product-warranty-addon";
            addonInput.id = "bt51-warranty-addon-choice";
            addonInput.value = "addon";
            warrantyList.appendChild(addonInput);
        }

        if (!addonLabel) {
            addonLabel = document.createElement("label");
            addonLabel.className = "bt51-warranty-display";
            addonLabel.setAttribute("for", "bt51-warranty-addon-choice");
            addonLabel.innerHTML = '<span class="bt51-warranty-option-name"></span>';
            warrantyList.appendChild(addonLabel);
        }

        productInter.renderWarrantyAddonOption(addonLabel, optionTerm, optionPriceData);
        if (noneInput) noneInput.checked = !shouldSelectAddon;
        addonInput.checked = shouldSelectAddon;
        productInter.setWarrantyAddonSelected(shouldSelectAddon);
        productInter.refreshOptionDropdowns();
    },
    // Wire warranty addon radio changes.
    setupWarrantyAddonDropdown: function () {
        var warrantySection = document.getElementById("bt51-warrantySection"),
            warrantyList = document.getElementById("bt51-warranty-list");

        if (!warrantySection || !warrantyList || warrantySection.dataset.warrantyDropdownReady == "true") return;

        warrantySection.dataset.warrantyDropdownReady = "true";
        warrantyList.addEventListener("change", function (event) {
            if (!event.target.classList || !event.target.classList.contains("bt51-warranty-choice")) return;
            productInter.setWarrantyAddonSelected(event.target.value == "addon");
            productInter.refreshOptionDropdowns();
        });

        productInter.setWarrantyAddonSelected(false);
    },
    // Check whether the warranty addon is selected in either UI layer.
    isWarrantyAddonSelected: function () {
        var addonInput = document.getElementById("bt51-warranty-addon-choice"),
            warrantySection = document.getElementById("bt51-warrantySection");

        return !!((addonInput && addonInput.checked) || (warrantySection && warrantySection.classList.contains("bt51-product-section--warranty-selected")));
    },
    // Keep visible warranty option state in sync.
    setWarrantyAddonSelected: function (selected) {
        var warrantySection = document.getElementById("bt51-warrantySection"),
            selectedChoice = document.getElementById(selected ? "bt51-warranty-addon-choice" : "bt51-warranty-none");

        if (selectedChoice && !selectedChoice.disabled) {
            selectedChoice.checked = true;
        }

        if (warrantySection) {
            warrantySection.classList.toggle("bt51-product-section--warranty-selected", selected);
            productInter.syncOptionDropdown(warrantySection);
        }
    },
    // Fetch and render warranty addon data for the selected variant.
    getAddonItems: function (addonItems) {
        var keepWarrantySelected = productInter.isWarrantyAddonSelected(),
            normalizedAddons = Array.isArray(addonItems) ? addonItems : addonItems ? [addonItems] : [],
            warrantyHandle = normalizedAddons[0];

        if (!warrantyHandle) {
            productInter.warrantyAddonHandle = "";
            productInter.warrantyAddonVariantId = "";
            productInter.updateWarrantyAddonDisplay(false);
            productInter.setWarrantyAddonSelected(false);
            return false;
        }

        if (productInter.warrantyAddonHandle == warrantyHandle && productInter.warrantyAddonVariantId) {
            productInter.setWarrantyAddonSelected(keepWarrantySelected);
            productInter.refreshOptionDropdowns();
            return;
        }

        productInter.warrantyAddonHandle = warrantyHandle;
        productInter.warrantyAddonVariantId = "";
        productInter.updateWarrantyAddonDisplay(false);
        productInter.setWarrantyAddonSelected(false);

        $.getJSON("/products/" + warrantyHandle + ".js", function (item) {
            if (productInter.warrantyAddonHandle != warrantyHandle) return;

            var warrantyVariant = productInter.getWarrantyAddonVariant(item);
            if (!warrantyVariant || warrantyVariant.available === false) {
                productInter.warrantyAddonHandle = "";
                productInter.warrantyAddonVariantId = "";
                productInter.updateWarrantyAddonDisplay(false);
                productInter.setWarrantyAddonSelected(false);
                return false;
            }

            var addonPrice = productInter.formatWarrantyAddonPrice(item, warrantyVariant),
                warrantyTerm = productInter.getWarrantyAddonTerm(item, warrantyVariant, warrantyHandle),
                warrantyPrice = parseInt(warrantyVariant.price, 10),
                shouldAutoSelectWarranty = !isNaN(warrantyPrice) && warrantyPrice <= 0;

            productInter.warrantyAddonVariantId = warrantyVariant.id;
            productInter.updateWarrantyAddonDisplay(true, warrantyTerm, addonPrice, keepWarrantySelected || shouldAutoSelectWarranty);
        }).fail(function () {
            if (productInter.warrantyAddonHandle == warrantyHandle) {
                productInter.warrantyAddonHandle = "";
                productInter.warrantyAddonVariantId = "";
                productInter.updateWarrantyAddonDisplay(false);
                productInter.setWarrantyAddonSelected(false);
            }
        });
    },
    // Sync open accordion content heights for CSS transition.
    syncProductAccordionHeights: function () {
        document.querySelectorAll(".bt51-product-accordion__item--open .bt51-product-accordion__content").forEach(function (content) {
            content.style.maxHeight = content.scrollHeight + "px";
        });
    },
    // Open or close a product accordion item.
    setProductAccordionItem: function (item, shouldOpen) {
        var trigger = item ? item.querySelector(".bt51-product-accordion__trigger") : null,
            content = item ? item.querySelector(".bt51-product-accordion__content") : null;

        if (!item || !trigger || !content) return;

        if (shouldOpen) {
            content.style.maxHeight = content.scrollHeight + "px";
            item.classList.add("bt51-product-accordion__item--open");
        } else {
            item.classList.remove("bt51-product-accordion__item--open");
            content.style.maxHeight = "0px";
        }

        trigger.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
        content.setAttribute("aria-hidden", shouldOpen ? "false" : "true");
    },
    // Initialize product information accordions.
    initProductAccordions: function () {
        document.querySelectorAll("[data-product-accordion]").forEach(function (accordion) {
            if (accordion.dataset.accordionReady == "true") return;

            var items = accordion.querySelectorAll(".bt51-product-accordion__item");
            accordion.dataset.accordionReady = "true";

            items.forEach(function (item) {
                var trigger = item.querySelector(".bt51-product-accordion__trigger");

                productInter.setProductAccordionItem(item, item.classList.contains("bt51-product-accordion__item--open"));
                if (!trigger) return;

                trigger.addEventListener("click", function () {
                    var shouldOpen = !item.classList.contains("bt51-product-accordion__item--open");

                    productInter.setProductAccordionItem(item, shouldOpen);
                });
            });
        });
    },
    // Show or hide the mobile sticky purchase bar after the main buy box leaves view.
    updateMobileStickyPurchaseBarVisibility: function () {
        var stickyBar = document.getElementById("bt51-mobileStickyPurchase"),
            buyBox = document.getElementById("bt20-collectionBuyBox"),
            cart = document.querySelector(".bt20-csb_cart"),
            notifymeContainer = document.querySelector(".bt32-notifymeContainer"),
            restockRocketContainer = document.querySelector(".restock-rocket-button-container"),
            mainButton = document.getElementById("bt20-csb_cartBtn");

        if (!stickyBar) return;

        var isMobile = window.matchMedia ? window.matchMedia("(max-width: 650px)").matches : window.innerWidth <= 650,
            cartStyle = cart ? window.getComputedStyle(cart) : null,
            notifymeStyle = notifymeContainer ? window.getComputedStyle(notifymeContainer) : null,
            restockRocketStyle = restockRocketContainer ? window.getComputedStyle(restockRocketContainer) : null,
            cartVisible = !!(cart && cartStyle.display != "none" && cartStyle.visibility != "hidden"),
            notifymeVisible = !!(notifymeContainer && notifymeStyle.display != "none" && notifymeStyle.visibility != "hidden"),
            restockRocketVisible = !!(restockRocketContainer && restockRocketStyle.display != "none" && restockRocketStyle.visibility != "hidden"),
            buyBoxPast = !!(buyBox && buyBox.getBoundingClientRect().bottom <= 0),
            shouldShow = isMobile && buyBoxPast && cartVisible && !notifymeVisible && !restockRocketVisible && !!mainButton;

        stickyBar.classList.toggle("bt51-mobile-sticky-purchase--visible", shouldShow);
        stickyBar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
        document.body.classList.toggle("bt51-mobile-sticky-purchase-visible", shouldShow);
    },
    // Keep the mobile sticky purchase bar aligned with the currently selected variant.
    syncMobileStickyPurchaseBar: function () {
        var stickyBar = document.getElementById("bt51-mobileStickyPurchase"),
            stickyButton = document.getElementById("bt51-mobileStickyCartBtn"),
            mainButton = document.getElementById("bt20-csb_cartBtn"),
            productTitle = document.querySelector(".product_title"),
            productSubtitle = document.getElementById("bt51-productSubtitle"),
            currentPrice = document.getElementById("bt20-collection_price"),
            oldPrice = document.getElementById("b5-collection__old_price"),
            pricesWrap = document.getElementById("bt20-csb_pricesWrap"),
            reviewSource = document.querySelector(".bt20-csb_reviewStars .jdgm-preview-badge"),
            reviewTarget = document.getElementById("bt51-mobileStickyReview"),
            stateClasses = ["bt20-csb_activeCartBtn", "bt20-csb_preorderCartBtn", "bt32-csb_preorderClosed", "bt20-csb_addingItem"];

        if (!stickyBar) return;

        chairUtils.setText(stickyBar.querySelector(".bt51-mobile-sticky-purchase__title"), productTitle ? productTitle.textContent.trim() : "");
        chairUtils.setText(stickyBar.querySelector(".bt51-mobile-sticky-purchase__subtitle"), productSubtitle ? productSubtitle.textContent.trim() : "");
        chairUtils.setText(stickyBar.querySelector(".bt51-mobile-sticky-purchase__current-price"), currentPrice ? currentPrice.textContent.trim() : "");
        chairUtils.setText(stickyBar.querySelector(".bt51-mobile-sticky-purchase__old-price"), oldPrice ? oldPrice.textContent.trim() : "");
        stickyBar.classList.toggle("bt51-mobile-sticky-purchase--sale", !!(pricesWrap && pricesWrap.classList.contains("b5-on-sale-price") && oldPrice && oldPrice.textContent.trim()));

        if (reviewTarget) {
            var reviewClone = reviewSource ? reviewSource.cloneNode(true) : null;
            if (reviewClone) {
                // Keep the sticky badge visual-only to avoid duplicate aggregate ratings.
                reviewClone.querySelectorAll(".jdgm-prev-badge__rich-snippet").forEach(function (snippet) {
                    snippet.remove();
                });
            }
            var reviewHTML = reviewClone ? reviewClone.innerHTML.trim() : "";
            reviewTarget.innerHTML = reviewHTML;
            chairUtils.setDisplay(reviewTarget, reviewHTML ? "" : "none");
        }

        if (stickyButton && mainButton) {
            stateClasses.forEach(function (className) {
                stickyButton.classList.remove(className);
                if (mainButton.classList.contains(className)) stickyButton.classList.add(className);
            });
            stickyButton.disabled = mainButton.disabled;
        }

        productInter.updateMobileStickyPurchaseBarVisibility();
    },
    // Initialize mobile sticky purchase bar events.
    initMobileStickyPurchaseBar: function () {
        var stickyBar = document.getElementById("bt51-mobileStickyPurchase"),
            stickyButton = document.getElementById("bt51-mobileStickyCartBtn"),
            reviewSource = document.querySelector(".bt20-csb_reviewStars .jdgm-preview-badge"),
            ticking = false;

        if (!stickyBar || stickyBar.dataset.mobileStickyReady == "true") return;
        stickyBar.dataset.mobileStickyReady = "true";

        var scheduleVisibilityUpdate = function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
                ticking = false;
                productInter.updateMobileStickyPurchaseBarVisibility();
            });
        };

        if (stickyButton) {
            stickyButton.addEventListener("click", function (event) {
                event.preventDefault();
                productInter.addToCart(this);
            });
        }

        window.addEventListener("scroll", scheduleVisibilityUpdate, { passive: true });
        window.addEventListener("resize", function () {
            productInter.syncMobileStickyPurchaseBar();
            scheduleVisibilityUpdate();
        });

        if (reviewSource && window.MutationObserver) {
            new MutationObserver(function () {
                productInter.syncMobileStickyPurchaseBar();
            }).observe(reviewSource, { childList: true, subtree: true, characterData: true });
        }

        productInter.syncMobileStickyPurchaseBar();
        setTimeout(productInter.syncMobileStickyPurchaseBar, 600);
        setTimeout(productInter.syncMobileStickyPurchaseBar, 1800);
    },
    // Submit notify-me request for unavailable variants.
    notifyMe: function (target) {
        if (!target || target.classList.contains("disabled")) return;
        var notifymeData = document.getElementById("bt32-notifyme_data");
        if (!notifymeData) return;
        if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(notifymeData.value)) {
            alert("有効なメールアドレスを入力してください。");
            return;
        }
        var requestData = JSON.parse(JSON.stringify(notifymeData.dataset));
        requestData["email"] = notifymeData.value;
        $.ajax({
            type: "POST",
            url: "https://app.boulies.com/notifyorders/notifyme",
            data: requestData,
            // Show notify-me loading state before submit.
            beforeSend: function () {
                target.classList.add("disabled");
                target.innerHTML = "送信中...";
            },
            // Restore notify-me state if the request fails.
            error: function (xhr, status, error) {
                alert("通知リクエストの送信に失敗しました。時間をおいて再度お試しください。");
                target.classList.remove("disabled");
                target.innerHTML = "登録";
            },
            // Confirm notify-me subscription on success.
            success: function () {
                target.innerHTML = "リクエストを受け付けました。";
            },
        });
    },
    // Initialize product page interactions.
    init: function () {
        productInter.makeVariantsMap();

        productInter.sortOptionsOnFirstLoad();

        productInter.changeUpholstery(true);

        productInter.setupOptionDropdowns();
        productInter.initMaterialCompareModal();
        productInter.initRestockRocketModalObserver();
        productInter.setupWarrantyAddonDropdown();
        productInter.initProductAccordions();
        productInter.initMobileStickyPurchaseBar();

        var cartBtn = document.getElementById("bt20-csb_cartBtn");
        if (cartBtn) {
            cartBtn.addEventListener("click", function (e) {
                e.preventDefault();
                productInter.addToCart(this);
            });
        }

        var notifyMeBtn = document.getElementById("bt32-notifymeBtn");
        if (notifyMeBtn) {
            notifyMeBtn.addEventListener("click", function (e) {
                e.preventDefault();
                productInter.notifyMe(this);
            });
        }

        document.querySelectorAll(".bt51-model").forEach(function (model) {
            model.addEventListener("change", function () {
                productInter.changeUpholstery();
            });
        });

        document.querySelectorAll(".bt51-upholstery").forEach(function (upholstery) {
            upholstery.addEventListener("change", function () {
                productInter.changeVariants();
            });
        });

        document.querySelectorAll(".bt51-variant").forEach(function (option) {
            option.addEventListener("change", function () {
                productInter.changeToThisOption(this);
            });
        });

        document.querySelectorAll(".bt51-variant-display").forEach(function (option) {
            var colorImage = chairPageData.colorImages[option.dataset.option2 + " / " + option.dataset.option3];
            if (colorImage) {
                option.style.backgroundImage = "url(" + colorImage + ")";
            }
        });

        window.addEventListener("popstate", (event) => {
            var url_param = productInter.getUrlParams();
            if (!url_param || !url_param.variant) return false;
            var selected_variant = document.querySelector('input[value="' + url_param.variant + '"]');
            if (!selected_variant) return false;
            selected_variant.checked = true;
            productInter.changeToThisOption(selected_variant, true);
        });

        window.addEventListener("resize", function () {
            productInter.initSaleCodeAutoScroll();
            productInter.syncProductAccordionHeights();
            productInter.syncMobileStickyPurchaseBar();
        });
    },
};

// ==============================================================
// Run Code After Document Ready
// ==============================================================
// Initialize page scripts after DOM is ready.
$(document).ready(function () {
    productInter.init();

    // Open LightGallery from the main product gallery.
    $(".bt20-csb_mainImage").on("click", ".pswp_image", function (e) {
        e.preventDefault();
        dynamicGallery.refresh([{ src: this.href }]);
        dynamicGallery.openGallery();
    });

    // Open LightGallery from dynamic description images.
    $(".dynamic-gallery-item").on("click", function (e) {
        e.preventDefault();
        dynamicGallery.refresh([{ src: this.href }]);
        dynamicGallery.openGallery();
    });

    // Toggle choose-guide content.
    var choose_guide = document.querySelector(".choose-guide-wrap__bt51");
    if (choose_guide) {
        choose_guide.addEventListener("click", function (e) {
            var trigger = e.target.closest(".choose-guide-header__bt51");
            if (!trigger) return;
            if (this.dataset.status == "is_actived") {
                this.dataset.status = "";
            } else {
                this.dataset.status = "is_actived";
            }
        });
    }

    // Inject Judge.me reward note when the URL requests it.
    if (productInter.getUrlParams().judgeme_dynamic_form == "1") {
        var injectDOM = document.createElement("div");
        injectDOM.style.display = "inline-block";
        injectDOM.innerHTML = '<p style=" background-color: #fcfff5; color: #2c662d; margin-top: 10px; padding: 10px 20px; border: 1px solid #a3c293; border-radius: 4px; text-align: left; font-size: 14px; "> <b style=" display: block; margin-bottom: 2px; font-size: 16px; ">Add picture/video for a reward.</b> By submitting with picture/video, boulies will offer 6 months extended warranty as a bonus.</p> <p style=" text-align: left; padding: 4px 20px 0; font-size: 14px; color: #6e6e6e; ">* A notification email will send to you when successfully submit a picture/video review.</p>';
        var insert_notify = setInterval(function () {
            if (document.querySelector(".jdgm-form-dynamic__picture-upload-field")) {
                document.querySelector(".jdgm-form-dynamic__picture-upload-field").appendChild(injectDOM);
                clearInterval(insert_notify);
            }
        }, 1000);
    }

    // Initialize best-of award carousel when present.
    if (!!document.querySelector(".bt51-bestof-wrap")) {
        var bestOfList = $(".bt51-bestofs").slick({
            slidesToShow: 3,
            dots: false,
            arrows: false,
            speed: 500,
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                    },
                },
            ],
        });
    }
});
